import { Text } from "@fluentui/react/lib/Text";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";

import { FilterToolTipContent } from "Components/Generic/FilterToolTipContent";
import { WithTranslator } from "Components/Generic/Translator";
import { formatCurrency } from "Utils/Number";
import { isNotNullOrWhiteSpace } from "Utils/String";
import { TooltipDirection, TooltipCloseDelay, TooltipOpenDelay } from "../TooltipSettings";
import { ICurrencyRendererProps } from "./ICurrencyRendererProps";
import { UseCurrencyRendererStyles } from "./UseCurrencyRendererStyles";

export const CurrencyRenderer = WithTranslator((props: ICurrencyRendererProps): JSX.Element => {
  const {
    fieldName, currencyFieldName, fallbackFieldName, item, translator, styles
  } = props;
  const styleSet = UseCurrencyRendererStyles(styles);

  const value = item?.[fieldName] as number;
  const fallbackValue = item?.[fallbackFieldName] as string;
  const currency = item?.[currencyFieldName] as string;

  let content = isNotNullOrWhiteSpace(fallbackValue) ? fallbackValue : translator.get(`generic.unknown`, `Unknown`);
  if (value != null && value !== 0) {
    content = formatCurrency(translator.getActiveLocale(), value, currency);
  }

  return (
    <TooltipHost
      closeDelay={TooltipCloseDelay}
      content={
        <FilterToolTipContent fieldName={fieldName} value={content} rawValue={`=${item?.[fieldName] as number}`} />
      }
      delay={TooltipOpenDelay}
      directionalHint={TooltipDirection}
      hostClassName={styleSet.host}
    >
      <div className={styleSet.root}>
        <Text>{content}</Text>
      </div>
    </TooltipHost>
  );
});
